import React, { useEffect } from 'react';
import { ProgressCircular } from '@americanexpress/dls-react';
import { useDispatch } from 'react-redux';
import {
  useLoungeAirportLinkUrl,
  useLoungeById,
  useTranslatedAirportLounges,
} from '@/hooks/loungesHooks/loungesHelperHooks';
import { useRouteParams } from '@/context/routeParamsContext';
import RouteReplaceWithQueryParams from '../common/RouteReplaceWithQueryParams';
import LoungeDetailsHeroCarousel from './LoungeDetailsHeroCarousel';
import LoungeDetailsContent from './LoungeDetailsContent';
import { setLoungeDetails } from '../../duck/loungeDuck';

const LoungeDetailsPage = () => {
  const dispatch = useDispatch();
  const { isLoading } = useTranslatedAirportLounges();
  const { loungeId } = useRouteParams();
  const airportLinkUrl = useLoungeAirportLinkUrl(loungeId);
  const lounge = useLoungeById(loungeId);

  useEffect(() => {
    if (lounge) {
      dispatch(setLoungeDetails(lounge));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- set lounge details once lounge details are loaded
  }, [isLoading]);

  if (isLoading) {
    return (
      <div className="flex flex-justify-center dls-white-bg pad-4 margin-t">
        <ProgressCircular size="lg" />
      </div>
    );
  }

  if (!lounge) {
    return <RouteReplaceWithQueryParams to={`/${airportLinkUrl}`} />;
  }

  return (
    <>
      <LoungeDetailsHeroCarousel />
      <LoungeDetailsContent />
    </>
  );
};

export default LoungeDetailsPage;
